import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { AvailableLocale, availableLocales } from '@/i18n'
import { useAppSelector } from '@/redux/hooks'

/**
 * Syncs the Redux locale setting to i18n globally.
 * Should be called once near the root of the app.
 *
 * When locale is 'auto', the browser language is used (stripping region, e.g. sv-SE → sv).
 * Falls back to 'sv' if the detected language is not supported.
 */
export const useLocaleSync = () => {
  const { i18n } = useTranslation()
  const locale = useAppSelector(state => state.settings.locale)

  useEffect(() => {
    let targetLang: AvailableLocale

    if (locale === 'auto') {
      const [browserLang] = navigator.language.split('-')
      targetLang = availableLocales.includes(browserLang as AvailableLocale)
        ? (browserLang as AvailableLocale)
        : 'sv'
    } else {
      targetLang = locale
    }

    if (i18n.language !== targetLang) {
      i18n.changeLanguage(targetLang)
    }
  }, [locale, i18n])
}
